export const CAMPAIGN_PARAMS_SCOPE = "withinCampaignScope";
